import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonApiService } from '../CommonController/common-api-service';
import { DeviceModelApiService } from '../CommonController/device-model-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';
@Component({
  selector: 'app-model-firmware-page',
  templateUrl: './model-firmware-page.component.html',
  styleUrls: ['./model-firmware-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
  ],
})
export class ModelFirmwarePageComponent implements OnInit {
  ModelFirmwareForm: FormGroup;
  userPermission = [];
  isAddForm = true;
  ModelFirmwareCreate = true;
  ModelFirmwareUpdate = true;
  loggedId = '';
  model_id = '';
  constructor(
    public deviceModelApiService: DeviceModelApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.model_id = this.route.snapshot.paramMap.get('id');
    this.checkPermission();
    this.setAddDeviceModelForm();
    if (this.model_id !== null) {
      this.isAddForm = false;
      this.prePopulation(this.model_id);
    } else {
      this.isAddForm = true;
    }
  }

  checkPermission() {
    this.loggedId = sessionStorage.getItem('loggedInUserId');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermissions'));
    if (this.model_id !== null) {
      this.userPermission.forEach((element) => {
        if (element.pageName === 'Model') {
          if (element.update === false) {
            this.navigateBack();
          }
        }
      });
    } else {
      this.userPermission.forEach((element) => {
        if (element.pageName === 'Model') {
          if (element.create === false) {
            this.navigateBack();
          }
        }
      });
    }
  }

  setAddDeviceModelForm() {
    this.ModelFirmwareForm = this.fb.group({
      // ModelFirmwareSearch: new FormControl(""),
      modelId: new FormControl(''),
      modelCode: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.singleSpaceOrHyphen,
      ]),
      modelName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.singleSpaceOrHyphen,
      ]),
      modelSerialSequence: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.alphaNumericOnly,
      ]),
      hardwareVersion: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.alphaNumericOnly,
      ]),
      userId: new FormControl(
        this.loggedId,
        SharedValidators.requiredAndNoEmptySpaces
      ),
    });
  }
  prePopulation(modelId) {
    this.spinner.show();
    this.deviceModelApiService
      .getDeviceModelDataById(modelId)
      .subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          const data = res.data;
          this.ModelFirmwareForm = this.fb.group({
            modelId: new FormControl(data.modelId),
            modelCode: new FormControl(data.modelCode, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.singleSpaceOrHyphen,
            ]),
            modelName: new FormControl(data.modelName, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.singleSpaceOrHyphen,
            ]),
            modelSerialSequence: new FormControl(data.modelSerialSequence, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.alphaNumericOnly,
            ]),
            hardwareVersion: new FormControl(data.hardwareVersion, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.alphaNumericOnly,
            ]),
            userId: new FormControl(
              this.loggedId,
              SharedValidators.requiredAndNoEmptySpaces
            ),
          });
        } else {
          console.error('API Response error:', res.message);
        }
      });
  }

  validateFormUpdate() {
    if (this.ModelFirmwareForm.invalid) {
      SharedValidators.markAllAsTouched(this.ModelFirmwareForm);
    } else {
      this.updateData();
    }
  }
  validateFormSave() {
    if (this.ModelFirmwareForm.invalid) {
      SharedValidators.markAllAsTouched(this.ModelFirmwareForm);
    } else {
      this.saveData();
    }
  }
  saveData() {
    // this.spinner.show();
    const payload = this.ModelFirmwareForm.value;
    payload.createdAt = Date.now();
    this.deviceModelApiService.saveDeviceModel(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.router.navigate(['model']);
        } else {
          this.spinner.hide();
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        const example = ERROR.error.message;
        this.commonApiService.openSnackbar(example);
      },
    });
  }

  updateData() {
    this.spinner.show();
    const payload = this.ModelFirmwareForm.value;
    payload.id = this.model_id;
    payload.updatedAt = Date.now();
    this.deviceModelApiService
      .updateDeviceModelData(this.model_id, payload)
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            this.redirect('model');
            this.ModelFirmwareUpdate = false;
            this.ModelFirmwareCreate = true;
            this.commonApiService.openSnackbar(res.message);
          } else {
            this.commonApiService.openSnackbar(res.message);
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          const example = ERROR.error.message;
          this.commonApiService.openSnackbar(example);
        },
      });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
  navigateBack() {
    this.commonApiService.back();
  }
}
